import { render, staticRenderFns } from "./excel.vue?vue&type=template&id=38413f6b&scoped=true&"
import script from "./excel.vue?vue&type=script&lang=js&"
export * from "./excel.vue?vue&type=script&lang=js&"
import style0 from "./excel.vue?vue&type=style&index=0&id=38413f6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38413f6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38413f6b')) {
      api.createRecord('38413f6b', component.options)
    } else {
      api.reload('38413f6b', component.options)
    }
    module.hot.accept("./excel.vue?vue&type=template&id=38413f6b&scoped=true&", function () {
      api.rerender('38413f6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/consign/components/import/excel.vue"
export default component.exports